import { useContext } from 'preact/hooks';
import { ButtonSetContext } from './ButtonSetContext';

/**
 * Utility hook for consuming the ButtonSetContext
 *
 * @returns The value of closest ButtonSetControl provider
 */
function useButtonSetContext() {
  return useContext(ButtonSetContext);
}

export { useButtonSetContext };
